export default "__VITE_ASSET__C$M2OGTj__"